<template>
  <div class="preview-card--wrap" :class="{ activecard: active }">
    <div class="header--wrap" :class="{ active: active }">
      <div class="heading-wrap text-block-title">{{ heading }}</div>
      <button class="header-button" @click="$emit('header-button', model)">
        <fluent-icon v-show="isEditable" icon="delete" size="24" class="white-icon" />
      </button>
    </div>
    <div class="content-wrap">
      {{ content }}
    </div>
    <div class="image-wrap">
      <img v-show="src" :src="src" class="image" :class="{ activeimage: active }" />
    </div>
    <div class="button-wrap" :class="{ 'single-button': !isEditable }">
      <woot-button v-show="isEditable" @click="$emit('primary-action', model)">{{ primaryButtonText }}</woot-button>
      <woot-button @click="$emit('secondary-action', model)">{{ secondaryButtonText }}</woot-button>
    </div>
  </div>
</template>

<script>
import WootButton from './WootButton.vue';
export default {
  components: { WootButton },
  props: {
    heading: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    primaryButtonText: {
      type: String,
      default: '',
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
    secondaryButtonText: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      default: '',
    },
    model: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-card--wrap {
  border-radius: var(--border-radius-normal);
  border: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  max-height: 34rem;
  max-width: 30rem;
  min-width: 30rem;

  .header--wrap {
    background: var(--color-woot);
    color: var(--w-25);
    border-bottom: 1px solid var(--color-border);
    border-top-left-radius: var(--border-radius-normal);
    border-top-right-radius: var(--border-radius-normal);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 4rem;
    padding: var(--space-small);
    position: relative;
    width: 100%;
  }

  .header-button {
    position: absolute;
    right: var(--space-small);
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
  }

  .button-wrap {
    display: flex;
    padding: 15px;
    border-top: 1px solid var(--color-border);
    justify-content: space-between;

    &.single-button {
      justify-content: flex-end;
    }
  }

  .active {
    background: var(--w-50);
    border-bottom: 1px solid var(--g-20);
  }

  .heading-wrap {
    font-weight: var(--font-weight-medium);
    padding: var(--space-smaller);
    text-align: center;
    flex: 1;
  }

  .checkmark {
    color: var(--w-500);
  }

  .content-wrap {
    color: var(--b-600);
    font-size: var(--font-size-mini);
    line-height: 1.4;
    padding: var(--space-slab) var(--space-slab) 0 var(--space-slab);
    text-align: center;
  }

  .image-wrap {
    padding: var(--space-slab);
  }

  .white-icon {
    color: white;
  }

  .image {
    border: 1px solid var(--g-20);
    border-radius: var(--border-radius-normal);
  }

  .activeimage {
    border: 1px solid var(--g-20);
  }
}

.activecard {
  background: var(--w-25);
  border: 1px solid var(--g-20);
}
</style>